import { render, staticRenderFns } from "./FBadge.vue?vue&type=template&id=75f00cb0&scoped=true&"
import script from "./FBadge.vue?vue&type=script&lang=ts&"
export * from "./FBadge.vue?vue&type=script&lang=ts&"
import style0 from "./FBadge.vue?vue&type=style&index=0&id=75f00cb0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f00cb0",
  null
  
)

export default component.exports